import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Tabs, TabsProps, units } from '@ha/dsl';

const useStyles = makeStyles(t => ({
  root: {
    borderRadius: units.rem(2.125),
    backgroundColor: t.palette.grey[50],
    height: units.rem(4.125),
  },
  scroller: {
    display: 'flex',
    alignItems: 'center',
    padding: units.yx(0, 0.5),
  },
  indicator: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    padding: units.yx(0.5, 0),
  },
  toggle: {
    height: '100%',
    flex: 1,
    boxShadow: 'rgba(0, 0, 0, 0.11) 0px 2px 9px 0px',
    borderRadius: units.rem(2.125),
    backgroundColor: t.palette.white.main,
  },
}));

const StyledTabs: React.FC<TabsProps> = props => {
  const { toggle, ...restClasses } = useStyles();

  return (
    <Tabs
      {...props}
      classes={restClasses}
      TabIndicatorProps={{
        children: <div className={toggle} />,
      }}
    />
  );
};

export default StyledTabs;
